import { render } from "./TemplateListItem.vue?vue&type=template&id=16df901f&scoped=true"
import script from "./TemplateListItem.vue?vue&type=script&lang=js"
export * from "./TemplateListItem.vue?vue&type=script&lang=js"

import "./TemplateListItem.vue?vue&type=style&index=0&id=16df901f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16df901f"]])

export default __exports__